import { clientStore } from 'apps/client/app';
import styled from 'styled-components';
import {
  MobileFrameHeaderHeight,
  OldFrameSidebarWidth,
  CADSidebarWidth,
} from 'styles/constants';
import { customMedia } from 'styles/utils';

export const TabsWrapperStyled = styled.div`
  z-index: 1007;
  position: fixed;
  left: ${props => props.left ?? CADSidebarWidth}px;
  top: ${props => props.top}px;
  ${customMedia.lessThan('medium')`
    left: 0;
    top: ${MobileFrameHeaderHeight}px;
  `}
  margin-top: ${props => props.theme.space[1]};
  height: ${props => props.tabHeight}px;
  display: flex;
  align-items: center;
  flex-direction: row;
`;

export const CadViewerStyled = styled.div`
  pointer-events: none;
  position: fixed;
  right: 0;
  bottom: 0;
  top: ${props => `${props.top ?? clientStore.PageHeaderHeight}px`};
  left: ${OldFrameSidebarWidth}px;
  ${customMedia.lessThan('medium')`
    left: 0;
  `}
  margin-left: 0;
  margin-right: 0;
  z-index: 1001;
  overflow: hidden;
`;

export const PreviewCadViewerStyled = styled.div`
  position: relative;
  height: ${props => (props.height ? `${props.height}px` : '100%')};
  width: ${props => (props.width ? `${props.width}px` : '100%')};
  top: 0;
  overflow: hidden;
`;

export const CadViewerWrapper = styled.section`
  position: absolute;
  top: ${clientStore.PageHeaderHeight}px;
  right: 0;
  bottom: 0;
  left: ${OldFrameSidebarWidth}px;
  ${customMedia.lessThan('medium')`
    left: 0;
  `}
  width: calc(100% - ${OldFrameSidebarWidth}px);
  ${customMedia.lessThan('medium')`
    width: 100%;
    `}
  height: 100%;
  background-color: white;
  font-family: 'HelveticaNowDisplay';
  /* FIXME: remove this tweak once new viewer can be merged with new-brand branch. */
  &&& {
    [data-id='tooltip'] {
      border-radius: 0;
    }
  }
`;
